import { setupFormState } from '@/components/form/tidal-form'
import { PreferencesFormValues } from '../types'

export const form = setupFormState<PreferencesFormValues>({
  id: 'preferences-form',
  initialValues: {
    companyFromName: '',
    dateFormat: 'MMMD',
    timeFormat: 'H12',
    notificationLanguage: '',
  },
})
